import Contacts from './Contacts'

export default Contacts



// WEBPACK FOOTER //
// ./src/features/Contacts/components/Contacts/index.js